import { Component, Host, h, Prop, Element, Method, State, Listen } from '@stencil/core';
import Flickity from 'flickity';
// import Swiper from 'swiper';

@Component({
  tag: 'as-product-overlay',
  styleUrl: 'as-product-overlay.css',
  shadow: true,
})
export class AsProductOverlay {
  @Element() el: HTMLElement;

  @Prop({ mutable: true }) product?: any;
  @Prop({ mutable: true }) channel?: any;
  @Prop() trackevent?: any = null;
  @Prop() env?: string = 'live';
  @Prop() player?: any = null;
  @Prop() photoviewer?: any = null;

  @State() visible = false;
  @State() selectedOptions = [];
  @State() addedToCart?: boolean = false;
  @State() addToCartLoading: boolean = false;
  @State() selectedVariant: any = null;
  @State() hasVariants: boolean = false;
  @State() optionerrors: any = {};
  @State() disabledoptions: any = {};
  @State() sizeGuideVisible: boolean = false;

  private flkcsl: any;
  private theme?: string = 'dark';
  private quickcart?: number = 0;
  private imagesize?: string = 'small';
  private sizeGuide?: string = null;
  private toastMsg?: string = '';


  componentWillLoad() {
    this.product = this.setData(this.product);
    this.setupChannel();
    this.setupSf();
  }
  componentDidLoad() {
    // Then we set the value in the --vh custom property to the root of the document
    this.setVw();
    // console.log('product cart loaded', this.theme, this.quickcart, this.imagesize);
    this.setupFlkty();
  }

  @Method()
  async isVisible() {
    return this.visible;
  }

  @Method()
  async open(product, channel = null, player, photoviewer, trackevent) {
    this.player = player;
    // console.log('player', this.player);
    this.player?.pause();
    this.photoviewer = photoviewer;
    this.product = this.setData(product);
    this.channel = channel;
    this.trackevent = trackevent;
    this.setupChannel();
    this.setupSf();
    this.setupFlkty();

    this.visible = true;

    // this.player?.player?.pause();
    // console.log(this.el.shadowRoot.querySelector('#product-details-popup'));
    // this.el.shadowRoot.getElementById('product-details-popup').style.height = "70%";
    
    this.triggerPushState(true);
    window.history.replaceState({
      fullscreen: true,
      overlay: {
        open: true,
        sizeGuideVisible: false,
      }
    }, null, "");
    this.trackevent("open_product_details_overlay", {
      ...this.geteventattributes(this),
    }, this.player || this.photoviewer);
  }

  @Method()
  async close(play = true) {
    // this.el.shadowRoot.getElementById('product-details-popup').style.height = "0%";
    if(this.visible) {
      this.trackevent("close_product_details_overlay", {
        ...this.geteventattributes(this),
      }, this.player || this.photoviewer);
      this.product = null;
      this.channel = null;
      if(play) {
        this.player?.play();
      }
      this.visible = false;
      this.addedToCart = false;
      this.sizeGuideVisible = false;
      this.selectedOptions = [];
      this.selectedVariant = null;
      this.optionerrors = {};
      this.triggerPushState(false);
      window.history.replaceState({
        fullscreen: true,
      }, null, "");
    }
  }

  @Method()
  async handleOverlay(e) {
    e.preventDefault();
    const state = e.state;
    if(!state?.overlay) {
      this.close();
    } else {
      const overlayprop = state?.overlay;
      if(!overlayprop.sizeGuide && overlayprop.open) {
        this.sizeGuideVisible = false;
      } else if (overlayprop.open){
        this.player?.pause();
        this.visible = true;
        window.history.replaceState({
          fullscreen: true,
          overlay: {
            open: true,
            sizeGuideVisible: false,
          }
        }, null, "");
      } else {
        this.player?.play();
        this.visible = false;
        window.history.replaceState({
          fullscreen: true,
        }, null, "");
      }
    }
  }

  @Listen('resize', { target: 'window', passive: true })
  async windowResize() {
    // show a prompt
    this.setVw();
  }

  render() {
 
      return (
        <Host>

          <div class={{
            overlay: this.visible,
            backdrop: this.visible, 
            darkBackdrop: (this.theme === 'dark'),
            lightBackdrop: (this.theme === 'light'),
            quickCart: (this.quickcart ? true : false),
            }} onClick={() => { if(this.sizeGuideVisible) {
            this.sizeGuideVisible = false; 
            this.triggerPushState(true);
          }
            else {
              this.close();
          }}}></div>

<div class={{
              overlay: true,
              dark: (this.theme === 'dark'),
              light: (this.theme === 'light'),
              overlayopen: this.visible,
            }} id="product-details-popup">
            {this.product && <div class="product-content">
             
             <div class="header">
             <div class={{
  "product-card": true,
  "dark": (this.theme === 'dark'),
  "light": (this.theme === 'light'),
}} >
  <img class="product" onClick={()=>{ window.location.href = this.getVariantUrl(); }} src={this.product.platformProduct.featuredImage.url} alt={this.product.platformProduct.title} />
    <div class="product-card-body" onClick={()=>{ window.location.href = this.getVariantUrl(); }}>
      <div class="product-card-item-name">{this.product.platformProduct.title}</div>
      {this.product.price && <div class="product-card-item-price">
        <span class="unit-price-label">
          {this.product.currencySymbol}{this.product.price}{this.product.discount ? (<span class="discount-price-container"> <strike>{this.product.currencySymbol}{this.product.compareAtprice}</strike> <span class="percentoff">({this.product.discount}% Off)</span></span>) : (<span></span>)}
        </span>
      </div>}
    </div>
    <div class="close-overlay" onClick={() => { this.close(); }}>
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill={this.theme === 'dark' ? '#424242' : '#B5B5B5'}/>
</svg>
    </div>
  </div>
            </div>

            <div class="flexWrapper">
            <main class="vmWrapper">
              <div class={{
                productImages: true,
                'large': (this.imagesize === 'large'),
                'small': (this.imagesize === 'small'),
                swiper: true,
              }} id={`product-overlay-carousel-${this.product?.platformProduct?.images?.edges?.length}`}>
                <div class="swiper-wrapper">
                  {this.product?.platformProduct?.images?.edges?.map(photo => (
                    <div class={{
                      'carousel-cell': true,
                      'swiper-slide': true,
                      'large': (this.imagesize === 'large'),
                      'small': (this.imagesize === 'small'),
                      'hidden': true,
                    }}>
                      <img src={photo.node.url} />
                    </div>
                  ))}
                </div>
              </div>

              {this.hasVariants && this.product.platformProduct.options.map((option: any, index) => (
                <div class={{
                  option: true,
                  border: (this.product.platformProduct.options.length-1 !== index),
                }} id={`product-variant-option-${option.name}`}>
                  <div class="label">{option.name}: {option.selectedValue}<span class="error">{this.optionerrors?.[option.name]}</span>
                  {option.name.toLowerCase() === 'size' && this.sizeGuide && <span class="guide" onClick={()=> { this.sizeGuideVisible = true; 
                   this.triggerPushState(true);
                  }}>Size Guide</span>}
                  </div>
                  <div class="optionitems">
                    {option.values.map((v) => (
                      <div class={`optionvalue ${option.optionType} ${this.disabledoptions?.[option.name]?.includes(v) ? 'disabled' : ''} ${option.selectedValue === v ? 'selected' : ''}`} onClick={() => this.disabledoptions?.[option.name]?.includes(v) ? false : this.selOption(v, option.name)}>{v}</div>
                    ))}
                  </div>
                </div>
              ))}

              {this.product.platformProduct.description && <div class={{
                productDetails: true,
                container: true,
                borderTop: this.product.platformProduct.options.length>0
              }}>
                <div class="heading">Product Details</div>
                <div class="description">{this.product.platformProduct.description}</div>
              </div>}

              <div id="snackbar">{this.toastMsg}</div>

            </main>

     
              <footer class="ctaLinkContainer">
                <div>
              <a href={this.getVariantUrl()} onClick={async (e) => {
                e.preventDefault();
                this.trackevent("view_product_details", {
                  ...this.geteventattributes(this),
                }, this.player || this.photoviewer);
                window.location.href = this.getVariantUrl();
              }} class="ctaLink viewDetails outlinebtn">View Details</a>
                <a class={{
                  ctaLink: true,
                }} onClick={async (e) => { 
                  e.preventDefault(); 
                  if(!this.addToCartLoading) 
                    await this.addItemtoCart();
                }} 
                title='Add to Cart'>{this.addToCartLoading ? (<div class="lds-ring"><div></div><div></div><div></div><div></div></div>) : 'Add to Cart'}</a>
                </div>
            
              </footer>
            

            </div>

            {this.sizeGuide && <div class={{
              sizeGuideWrapper: true,
              sizeGuideVisible: this.sizeGuideVisible,
            }}>

            <div class="header">
             <div class={{
  "dark": (this.theme === 'dark'),
  "light": (this.theme === 'light'),
}} >
  
    <div class="heading">Size Guide</div>
    <div class="close-overlay" onClick={() => { this.sizeGuideVisible = false; this.triggerPushState(true); }}>
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#424242"/>
</svg>
    </div>
  </div>
            </div>
              <img src={this.sizeGuide} />
              </div>}

   
            </div>}

            </div>
        </Host>
      );
    }

  getPrice(range) {
    let finalPrice = `${this.getCurrencySymbol(range.minVariantPrice.currencyCode)} ${range.minVariantPrice.amount}`;
    if(range.minVariantPrice.amount !== range.maxVariantPrice.amount) {
      finalPrice = `${this.getCurrencySymbol(range.minVariantPrice.currencyCode)} ${range.minVariantPrice.amount} - ${this.getCurrencySymbol(range.minVariantPrice.currencyCode)} ${range.maxVariantPrice.amount}`;
    }
    return finalPrice;
  }

  getVariantUrl() {
    const p = this.product?.platformProduct;
    let url = p?.onlineStoreUrl || `${this.product?.storefront?.url}/products/${p.handle}`;
    const w: any = window;
    if(w?.Shopify) {
      url = `//${window.location.host}/products/${p.handle}`;
    }
    if(p?.custom_url?.value) { // meta field
      url = p?.custom_url?.value;
    }
    url = `${url}?utm_campaign=allstudio&utm_medium=view_details&utm_source=product_detail_overlay`;
    if(this.selectedVariant) {
      url = `${url}&variant=${this.selectedVariant.id?.split('/')?.reverse()?.[0]}`;
    }
    return url;
  }

  getCurrencySymbol(currency) {
    var currency_symbols = {
      'USD': '$', // US Dollar
      'EUR': '€', // Euro
      'CRC': '₡', // Costa Rican Colón
      'GBP': '£', // British Pound Sterling
      'ILS': '₪', // Israeli New Sheqel
      'INR': '₹', // Indian Rupee
      'JPY': '¥', // Japanese Yen
      'KRW': '₩', // South Korean Won
      'NGN': '₦', // Nigerian Naira
      'PHP': '₱', // Philippine Peso
      'PLN': 'zł', // Polish Zloty
      'PYG': '₲', // Paraguayan Guarani
      'THB': '฿', // Thai Baht
      'UAH': '₴', // Ukrainian Hryvnia
      'VND': '₫', // Vietnamese Dong
    };
    if(currency_symbols[currency]!==undefined) {
      return currency_symbols[currency];
    }
  }

  setData(product) {
    if(product) {
      let np = product;
      const variants = np.platformProduct.variants?.edges;
      const availablevariants = variants.filter((va) => (va?.node?.availableForSale === true));
      np.defaultVariant = availablevariants?.[0]?.node;
      if(!np.defaultVariant) {
        np.defaultVariant = variants?.[0]?.node;
      }
      np.selectedVariant = null;
      if(np.platformProduct?.hasOnlyDefaultVariant || np.variants?.length === 1) {
        this.hasVariants = false;
        this.selectedVariant = variants?.[0]?.node;
      } else {
        this.hasVariants = true;

        variants.map((variant) => {
          if(variant?.node && !variant?.node?.availableForSale) {
            const opts = variant?.node?.selectedOptions;
            opts.map((opt) => {
              if(!this.disabledoptions[opt.name]) {
                this.disabledoptions[opt.name] = [];
              }
              this.disabledoptions[opt.name].push(opt.value);
            });
          }
        });

        np.platformProduct.options = np.platformProduct.options.map(o => {
          const no = o;
          no.optionType = 'circle';
          if(!no.selectedValue) {
            no.selectedValue  = null;
          }
          const seloption = this.selectedOptions.find((s) => (s.name === o.name));
          if(!seloption) {
            this.selectedOptions.push({ name: o.name, value: null });
          }
          no.values.map((nv) => {
            if(nv.length > 2) {
              no.optionType = 'default';
            }
            return 1;
          });
          return no;
        });
      }       
      np.currencySymbol = this.getCurrencySymbol(np.platformProduct.priceRangeV2.minVariantPrice.currencyCode);
      np = this.setPrice(np);
      return np;
    }
  }
  setPrice(product) {
    const np = product;
    const variant = this.selectedVariant ? this.selectedVariant : np.defaultVariant;
    np.price = parseFloat(variant?.price);
    // console.log(variant);
    if(variant.compareAtPrice) {
      np.compareAtprice = parseFloat(variant.compareAtPrice);
      np.discount = Math.round(((np.compareAtprice-np.price)/np.compareAtprice)*100);
    }
    return np;
  }

  setupFlkty() {
    const imagesLength = this.product?.platformProduct?.images?.edges?.length;
    const eleId = `product-overlay-carousel-${imagesLength}`;
    var elem = this.el?.shadowRoot.querySelector(`#${eleId}`);
    // console.log(elem);
    if(this.flkcsl){
      this.flkcsl.destroy();
    }
    if(elem) {
      const options = { 
        cellSelector: '.carousel-cell',
        percentPosition: false,
        pageDots: true,
        prevNextButtons: false,
        contain: true,
        cellAlign: 'left',

                // wrapAround: true,
      };
      if(imagesLength >= 5) {
        // options['wrapAround'] = true;
      }
      this.flkcsl = new Flickity(elem, options);
      this.el?.shadowRoot.querySelectorAll('.carousel-cell').forEach((ele) => ele.classList.remove('hidden'));
      // 
    } else if(this.product) {
      setTimeout(() => this.setupFlkty(), 100);
    }
  }

  checkVariantOptions(val1, val2) {
    let check = true;
    val1.forEach((v) => {
      const t = val2.find((v2) => (v2.name === v.name && v2.value === v.value ));
      if(!t) {
        check = false;
      }
    });
    return check;
  }

  selOption(value, name) {
    if(this.optionerrors?.[name]) {
      delete this.optionerrors[name];
      const opt = this.el.shadowRoot.querySelector(`#product-variant-option-${name}`);
      opt?.classList.remove('hasError');
    }
    const ind = this.selectedOptions.findIndex((s) => (s.name === name));
    // console.log('find option index', ind);
    if(ind === -1) {
      this.selectedOptions.push({ name, value });
    } else {
      this.selectedOptions[ind].value = value;
    }
    this.product.platformProduct.options = this.product.platformProduct.options.map((o)=> {
      const no = o;
      if(no.name === name) {
        no.selectedValue = value;
      } 
      return no;
    });
    this.selectedOptions = [...this.selectedOptions];
    const variants = this.product.platformProduct.variants?.edges;
    this.selectedVariant = variants?.find((v) => (this.checkVariantOptions(v.node.selectedOptions, this.selectedOptions)))?.node;
    this.setPrice(this.product);
    // console.log('selected variant', this.selectedVariant);
    // console.log(this.product.platformProduct.options);
  }
  checkedSelectedOption(value, name) {
    const ind = this.selectedOptions.findIndex((s) => (s.name === name && s.value === value));
    if(ind === -1) {
      return false;
    } else {
      return true;
    }
  }

  setupChannel() {
    if(this.channel) {
      var style = document.createElement( 'style' )
      style.innerHTML = `.overlay { --asplayer-btn-color: ${this.channel.primaryColor.hex}; --asplayer-btn-txt-color: ${this.channel.textColor.hex}; }`;
      this.el.shadowRoot.appendChild( style );
      this.theme = this.channel.productTheme;
      this.quickcart = this.channel.quickCart;
      this.imagesize = this.channel.productImageSize;
    }
  }
  setupSf() {
    if(this.product?.storefront) {
      this.sizeGuide = this.product.storefront.sizeGuide?.defaultImg?.finalUrls?.['576'] || null;
    }
  }

  isMobile() {
    const nav = navigator.userAgent.toLowerCase();
    return (
        nav.match(/iphone/i) || nav.match(/ipod/i) || nav.match(/ipad/i) || nav.match(/android/i)
    );
  };

  triggerPushState(open) {
    const st = {
      fullscreen: true,
    };
    if(open || this.sizeGuideVisible) {
      st['overlay'] = {
        open,
        sizeGuideVisible: this.sizeGuideVisible,
      };
    }
    window.history.pushState(st, null, "");
  }

  async addItemtoCart() {
    this.optionerrors = {};
    let errorcount = 0;
    const s = this;
    if(!this.selectedVariant) {
      if(this.product.platform === 'shopify' && this.hasVariants) {
        const options = this.product.platformProduct?.options;
        if(options) {
          options.forEach((o) => {
            const so = this.selectedOptions.find((s) => (s.name === o.name));
            const opt = s.el.shadowRoot.querySelector(`#product-variant-option-${o.name}`);
            opt.classList.remove('hasError');
            if(!so || !so.value) {
              this.optionerrors[so.name] = `Please select ${so.name.toLowerCase()}`;
              setTimeout(() => {
                opt.classList.add('hasError');
                errorcount++;
                if(errorcount <= 1) {
                  // opt.scrollIntoView({  behavior: 'smooth', block: 'nearest', inline: 'start'  });
                }
              },0);
            }
            
          });
        }
        try {
          this.isMobile() && window.navigator.vibrate(100);
        } catch(e) {
          // console.log('vibrate failed');
        }
        this.trackevent('addtocart_option_error', {
          category: 'product_details_overlay',
          errors: this.optionerrors,
          ...this.geteventattributes(this),
        }, this.player || this.photoviewer);
      } else {
        this.selectedVariant = this.product.platformProduct?.variants?.edges?.[0]?.node;
        await this.addItemtoCart();
      }
    }
    else {
      this.addToCartLoading = true;
      this.trackevent('addtocart_click', {
        category: 'product_details_overlay',
        ...this.geteventattributes(this),
      }, this.player || this.photoviewer);
      if(this.product.platform === 'shopify') {
        const result = await this.addShopifyItem();
        if(result.status === 200) {
          this.addedToCart = true;
          this.showSnackbar("Item added to cart.");
          this.trackevent('addtocart_success', {
            category: 'product_details_overlay',
            ...this.geteventattributes(this),
          }, this.player || this.photoviewer);
          const data = result?.data || {};
          if(!result.redirected) {
            // console.log(result);
            this.refreshShopifyCart(result);
            this.openCart();
          } else {
            this.addToCartLoading = false;
          }
          return data;
        } else {
          this.addToCartLoading = false;
          this.trackevent('addtocart_failure', {
            category: 'product_details_overlay',
            ...this.geteventattributes(this),
          }, this.player || this.photoviewer);
          return false;
        }
      }
    }
  }

  async addShopifyItem() {
    const variantid = this.selectedVariant.id.split("/").reverse()[0];
    const w: any = window;
    if(w?.allstudioAddtoCart) {
      const result = await w.allstudioAddtoCart(variantid);
      return result;
    } else {
      const result: any = await fetch(`/cart/add.json`, {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          },
          body: JSON.stringify({
              id: variantid,
              quantity: 1,
          })
      });
      result.data = await result.json();
      return result;
    }
  }


  showSnackbar(msg) {
    this.toastMsg = msg;
    var x = this.el.shadowRoot.getElementById("snackbar");

    // Add the "show" class to DIV
    x.className = "show";
  
    // After 3 seconds, remove the show class from DIV
    setTimeout(function(){ x.className = x.className.replace("show", ""); }, 3000);
  }

  openCart() {
    this.trackevent('open_cart', {
      category: 'product_details_overlay',
      forceredirect: this.channel.cartRedirect,
      ...this.geteventattributes(this),
    }, this.player || this.photoviewer);
    const w: any = window;
    if(w?.allstudioOpenCart) {
      w.allstudioOpenCart();
      this.addToCartLoading = false;
    } else {
      if(this.channel.cartRedirect) {
        window.location.href="/cart?utm_campaign=opencart&utm_source=allstudio&utm_medium=product_details_overlay";
      } else if(this.channel?.continueVideoAddtocart) {
        this.addToCartLoading = false;
      } else {
        var cartel: any = document.querySelector('a[href="/cart"]');
        cartel.click();
        this.addToCartLoading = false;
      }
    }
  }

  refreshShopifyCart(cart) {
/*
        setTimeout(function() {
          window.location.reload();
        }, 600);*/

  document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
              bubbles: true,
            }));
    document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
              bubbles: true,
              detail: {
                cart,
              }
            }));
      
  
  }

  setVw() {
    let vh = window.innerHeight * 0.01;
    let vw = window.innerWidth * 0.01;
    var style = document.createElement( 'style' )
    style.innerHTML = `:host { --vh: ${vh}px; --vw: ${vw}px;  } .overlay{ --vh: ${vh}px;  --vw: ${vw}px;  }`;
    this.el.shadowRoot.appendChild(style);
  }

  geteventattributes(s) {
    return {
      selectedOptions: s.selectedOptions,
      variantid: s.selectedVariant?.id,
      productid: s.product?.id,
      hasErrors: s.optionerrors.length > 0 ? true : false,
    };
  }

}
